import { createContext, useContext } from 'react';

import type { SectionMetadata } from '@spotify/confidence-core-react';

export type ContentNavigationSection = {
  id: string;
  label: string;
};

export type RegisteredContentSection = SectionMetadata & {
  element: HTMLElement;
};

export type ContentNavigationContextValue = {
  currentSection: string | undefined;
  registerSection: (
    id: string,
    section: RegisteredContentSection,
  ) => () => void;
  sections: ContentNavigationSection[];
  goToSection: (id: string) => void;
};

export const ContentNavigationContext =
  createContext<ContentNavigationContextValue | null>(null);

export const useContentNavigationContext =
  (): ContentNavigationContextValue => {
    const context = useContext(ContentNavigationContext);

    if (!context) {
      throw new Error(
        'Page.ContentNavigation must be declared before using its components',
      );
    }

    return context;
  };
